import { Zap, ShieldCheck, Globe2 } from "lucide-react";
import google from "@/assets/partners/google.svg.asset.json";
import cloudflare from "@/assets/partners/cloudflare.svg.asset.json";
import stripe from "@/assets/partners/stripe.svg.asset.json";
import meta from "@/assets/partners/meta.svg.asset.json";
import wordpress from "@/assets/partners/wordpress.svg.asset.json";
import supabase from "@/assets/partners/supabase.svg.asset.json";
import hostpoint from "@/assets/partners/hostpoint.svg.asset.json";
import openai from "@/assets/partners/openai.svg.asset.json";

const PARTNERS = [
  { name: "Google", url: google.url },
  { name: "Cloudflare", url: cloudflare.url },
  { name: "Stripe", url: stripe.url },
  { name: "Meta", url: meta.url },
  { name: "WordPress", url: wordpress.url },
  { name: "Supabase", url: supabase.url },
  { name: "Hostpoint", url: hostpoint.url },
  { name: "OpenAI", url: openai.url },
];

export function PartnersSection() {
  return (
    <section
      id="partners"
      className="relative border-y border-border bg-card/40"
    >
      <div className="pointer-events-none absolute inset-0 opacity-60" style={{ background: "var(--gradient-hero)" }} />
      <div className="relative mx-auto w-full max-w-6xl px-6 py-16 sm:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-background/60 px-3 py-1 text-xs font-medium text-muted-foreground backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-primary shadow-[0_0_10px_var(--primary)]" />
            Tecnologie utilizzate
          </div>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">
            Costruito sulle <span className="text-gradient">migliori piattaforme</span> del settore
          </h2>
          <p className="mt-4 text-muted-foreground">
            Utilizziamo strumenti affidabili e riconosciuti a livello internazionale per garantire
            velocità, sicurezza e prestazioni elevate.
          </p>
        </div>

        {/* Logo marquee */}
        <div className="mt-12 fw-marquee" style={{ ["--fw-duration" as never]: "32s" }}>
          <div className="fw-marquee-track">
            {[PARTNERS, PARTNERS].map((group, gi) => (
              <div key={gi} className="fw-marquee-group" aria-hidden={gi === 1}>
                {group.map((p) => (
                  <div
                    key={p.name + gi}
                    className="group flex h-24 w-44 shrink-0 items-center justify-center rounded-2xl border border-border bg-background/60 px-6 py-4 backdrop-blur transition-all hover:-translate-y-0.5 hover:border-primary/50 hover:bg-background/80"
                  >
                    <img
                      src={p.url}
                      alt={`${p.name} logo`}
                      loading="lazy"
                      className="max-h-8 max-w-[80%] object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0 [filter:brightness(0)_invert(1)] group-hover:[filter:none]"
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>





        {/* Trust bar */}
        <div className="mt-12 grid gap-4 sm:grid-cols-3">
          {[
            { icon: Zap, t: "Performance", d: "Siti ottimizzati per la velocità e i Core Web Vitals." },
            { icon: ShieldCheck, t: "Sicurezza", d: "Infrastruttura professionale con protezione e backup." },
            { icon: Globe2, t: "Standard moderni", d: "Compatibili con gli standard web più recenti." },
          ].map(({ icon: Icon, t, d }) => (
            <div
              key={t}
              className="flex items-start gap-3 rounded-2xl border border-border bg-background/40 p-5 backdrop-blur"
            >
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary">
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <h3 className="text-sm font-semibold">{t}</h3>
                <p className="mt-1 text-xs text-muted-foreground">{d}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xs text-muted-foreground">
          FlashWeb seleziona esclusivamente tecnologie affidabili e riconosciute per offrire ai
          clienti siti web moderni, veloci e pronti a crescere.
        </p>
      </div>
    </section>
  );
}
